import { render, staticRenderFns } from "./BusinessPartnerContactInformationForm.vue?vue&type=template&id=2b563b9e&"
import script from "./BusinessPartnerContactInformationForm.vue?vue&type=script&lang=js&"
export * from "./BusinessPartnerContactInformationForm.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPartnerContactInformationForm.vue?vue&type=style&index=0&id=2b563b9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports